import { render, staticRenderFns } from "./PorAno.vue?vue&type=template&id=0fb129bf&scoped=true"
import script from "./PorAno.vue?vue&type=script&lang=js"
export * from "./PorAno.vue?vue&type=script&lang=js"
import style0 from "./PorAno.vue?vue&type=style&index=0&id=0fb129bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb129bf",
  null
  
)

export default component.exports